/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */

import { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import { Link,useNavigate } from "react-router-dom";
// import notifications from "../../assets/json/notifications";
import {
  Applogo,
  Bar,
  MiniLogo
} from "../../Routes/ImagePath";

import useWebSocket from "api/useWebsocket";
import Image from "components/Image";
import { useAuth } from "context/userContext";
import { FaRegBell } from "react-icons/fa";
import { useLocation } from "react-router-dom/dist";
import { timeSince } from "utils/common";

import { updateNotification } from "api/services/common";
import { useDispatch } from "react-redux";
import { bulkNotificationChangeHandle,fetchNotificationData } from "store/slice/common";

const Header = (props) => {
  // const data = notifications.notifications;
  const [notification, setNotifications] = useState(false);
  const [profile, setProfile] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [headerGradient, setHeaderGradient] = useState("linear-gradient(to right, #667eea 0%, #f093fb 100%)");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  const {logout} = useAuth();
  const navigate = useNavigate();
  const {
    user,
    userLoading
} = useSelector((state) => state.user);

const { notifications,notificationLoading, sendMessage , notificationCount } = useWebSocket(user?.id)

const dispatch = useDispatch()



const viewNotificationHandler = async(val) => {
  await updateNotification(val?.id,{is_read:true})
  dispatch(fetchNotificationData({status: isRead}));

}
const filterNotifications = (e,status) => {
  e.stopPropagation(); // Prevent dropdown from closing

  setIsRead(status)
  dispatch(fetchNotificationData({status}));

}

const readDeleteNotification = (action) => {

  dispatch(bulkNotificationChangeHandle({action,status:isRead }));

}

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };
  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const themes = localStorage.getItem("theme");

  const handleNotification = () => {
    setNotifications(!notification);
    setProfile(false);
  };
  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
  };

  const location = useLocation();
  let pathname = location.pathname;
  // const { value } = useSelector((state) => state.user);
  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = `${user?.first_name || ""} ${user?.last_name || ""}`

    // Prevent closing when clicking inside
    const handleInsideClick = (event) => {
      event.stopPropagation();
    };

  const handleLogout = () =>{
    logout()
    navigate("/login")
  }

  // Get header gradient colors dynamically
  useEffect(() => {
    const headerElement = document.querySelector('.header');
    if (headerElement) {
      const computedStyle = window.getComputedStyle(headerElement);
      const bgImage = computedStyle.backgroundImage;
      if (bgImage && bgImage !== 'none') {
        setHeaderGradient(bgImage);
      }
    }
  }, []);

  // Detect mobile screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // The profile dropdown shows the email only when whoami provided one.
  // (A previous version tried GET api/token/ as a fallback - that endpoint
  // is POST-only and 405'd on every dropdown open.)
  useEffect(() => {
    if (profile && !userEmail && user?.email) {
      setUserEmail(user.email);
    }
  }, [profile, user?.email, userEmail]);
  return (
    <div className="header" style={{ right: "0px" }}>
      {/* Logo */}
      <div className="header-left">
        <Link to="/employee-dashboard"    className="logo main-logo d-flex justify-content-center align-items-center h-100">
          <img src={Applogo}  alt="img" />
        </Link>
        <Link to="/employee-dashboard"    className=" mini-logo d-flex justify-content-center align-items-center h-100 w-100">
          <img  src={MiniLogo}  alt="img" />
        </Link>
        {/* <Link to="/employee-dashboard" className="icon-logo">
          <img src={Applogo2}  style={{width:"60%"}} alt="img" />
        </Link> */}
      </div>
      {/* /Logo */}
      <Link
        id="toggle_btn"
        to="#"
        style={{
          display: pathname.includes("tasks")
            ? "none"
            : pathname.includes("compose")
              ? "none"
              : "",
        }}
        onClick={handlesidebar}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>
      {/* Header Title */}
      <div className="page-title-box d-flex">
        {/* <h2 className="font-weight-bold text-white " style={{alignSelf:"center"}} >ESS</h2> */}
        <img className="bar-image" src={Bar}  
        // style={{position:"absolute"}} 
        // className="h-100" 
        />
      </div>
      
      {/* /Header Title */}
      {/* <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
      >
        <i className="fa fa-bars" />
      </Link> */}
      {/* Header Menu */}
      <ul className="nav user-menu">
        {/* Search */}
        {/* <li className="nav-item">
          <div className="top-nav-search">
            <Link to="#" className="responsive-search">
              <i className="fa fa-search" />
            </Link>
            <form>
              <input
                className="form-control"
                type="text"
                placeholder="Search here"
              />
              <button className="btn" type="submit">
                <i className="fa fa-search" />
              </button>
            </form>
          </div>
        </li> */}
        {/* /Search */}
        {/* Notifications */}
        <li className="nav-item dropdown">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleNotification}
          >
            <i>
              <FaRegBell />
            </i>{" "}
            {
              notificationCount>0&&
              <span className="badge badge-pill">{notificationCount}</span>

            }
          </Link>
          <div
          data-bs-auto-close="false"
          onClick={handleInsideClick}
            className={`dropdown-menu dropdown-menu-end notifications-modern ${notification ? "show" : ""
              }`}
            style={{
              minWidth: "340px",
              maxWidth: "340px",
              padding: "0",
              borderRadius: "10px",
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(0, 0, 0, 0.06)",
              overflow: "hidden",
              marginTop: "8px"
            }}
          >
            {/* Compact Header */}
            <div style={{
              padding: "12px 16px",
              background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, rgb(244, 59, 72) 50%, rgb(252, 19, 61) 100%)",
              color: "white"
            }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <i className="fas fa-bell" style={{ marginRight: "8px", fontSize: "16px" }}></i>
                  <span style={{ fontSize: "15px", fontWeight: "600" }}>Notifications</span>
                  {notificationCount > 0 && (
                    <span style={{
                      marginLeft: "6px",
                      background: "rgba(255, 255, 255, 0.3)",
                      padding: "1px 6px",
                      borderRadius: "10px",
                      fontSize: "11px",
                      fontWeight: "600"
                    }}>
                      {notificationCount}
                    </span>
                  )}
                </div>
                <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      filterNotifications(e, "");
                    }}
                    style={{
                      background: isRead === false ? "rgba(255, 255, 255, 0.35)" : "rgba(255, 255, 255, 0.2)",
                      border: "none",
                      color: "white",
                      padding: "3px 10px",
                      borderRadius: "5px",
                      fontSize: "11px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)"}
                    onMouseLeave={(e) => e.currentTarget.style.background = isRead === false ? "rgba(255, 255, 255, 0.35)" : "rgba(255, 255, 255, 0.2)"}
                  >
                    All
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      filterNotifications(e, false);
                    }}
                    style={{
                      background: isRead === "" ? "rgba(255, 255, 255, 0.35)" : "rgba(255, 255, 255, 0.2)",
                      border: "none",
                      color: "white",
                      padding: "3px 10px",
                      borderRadius: "5px",
                      fontSize: "11px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)"}
                    onMouseLeave={(e) => e.currentTarget.style.background = isRead === "" ? "rgba(255, 255, 255, 0.35)" : "rgba(255, 255, 255, 0.2)"}
                  >
                    Unread
                  </button>
                </div>
              </div>
            </div>

            {/* Notification List */}
            <div style={{
              maxHeight: "360px",
              overflowY: "auto",
              background: "#ffffff"
            }}>
              {notifications.length === 0 ? (
                <div style={{
                  padding: "32px 16px",
                  textAlign: "center",
                  color: "#6c757d"
                }}>
                  <i className="far fa-bell-slash" style={{ fontSize: "28px", marginBottom: "10px", opacity: 0.5 }}></i>
                  <div style={{ fontSize: "13px" }}>No notifications</div>
                </div>
              ) : (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {notifications.map((val, index) => {
                    const isUnread = !val?.is_read;
                    return (
                      <li 
                        key={index}
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                          transition: "background-color 0.2s",
                          background: isUnread ? "#fff5f5" : "#ffffff"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fafafa"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isUnread ? "#fff5f5" : "#ffffff"}
                      >
                        <Link
                          to={val?.data?.type == "leave_request" ? `/leaves-employee?id=${val.data?.id}&modal=true` : val?.data?.type == "expense_claim" ? `/expenses?id=${val.data?.id}&modal=true` : "#"}
                          style={{
                            display: "flex",
                            padding: "10px 16px",
                            textDecoration: "none",
                            color: "inherit"
                          }}
                        >
                          <div style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "8px",
                            background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, rgb(244, 59, 72) 50%, rgb(252, 19, 61) 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            marginRight: "10px"
                          }}>
                            <i className={`fas ${val?.data?.type == "leave_request" ? "fa-calendar" : val?.data?.type == "expense_claim" ? "fa-dollar-sign" : "fa-bell"}`}
                              style={{ color: "white", fontSize: "14px" }}
                            ></i>
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{
                              fontSize: "13px",
                              fontWeight: isUnread ? "600" : "500",
                              color: "#212529",
                              marginBottom: "3px",
                              lineHeight: "1.4"
                            }}>
                              {val.title}
                            </div>
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "4px"
                            }}>
                              <span 
                                data-bs-toggle="tooltip"
                                title={val.created_at}
                                style={{
                                  fontSize: "11px",
                                  color: "#6c757d"
                                }}
                              >
                                {timeSince(val.created_at)}
                              </span>
                              <span
                                className="cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  if (!val?.is_read) {
                                    viewNotificationHandler(val);
                                  }
                                }}
                                style={{
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  transition: "background-color 0.2s"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e9ecef"}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                              >
                                <i className={val?.is_read ? "far fa-eye" : "far fa-eye-slash"}
                                  style={{
                                    color: val?.is_read ? "#6c757d" : "rgb(211, 0, 26)",
                                    fontSize: "12px"
                                  }}
                                ></i>
                              </span>
                            </div>
                          </div>
                          {isUnread && (
                            <div style={{
                              width: "6px",
                              height: "6px",
                              borderRadius: "50%",
                              background: "rgb(211, 0, 26)",
                              flexShrink: 0,
                              marginLeft: "6px",
                              marginTop: "3px"
                            }}></div>
                          )}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>

            {/* Footer Actions */}
            {notifications.length > 0 && (
              <div style={{
                padding: "10px 16px",
                borderTop: "1px solid #f0f0f0",
                background: "#fafafa",
                display: "flex",
                justifyContent: "center",
                gap: "12px"
              }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    readDeleteNotification("read");
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "rgb(211, 0, 26)",
                    fontSize: "12px",
                    fontWeight: "500",
                    cursor: "pointer",
                    padding: "3px 6px",
                    borderRadius: "4px",
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#fff5f5";
                    e.currentTarget.style.color = "#b3001a";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "rgb(211, 0, 26)";
                  }}
                >
                  <i className="fas fa-check-double" style={{ marginRight: "4px", fontSize: "11px" }}></i>
                  Mark Read
                </button>
                <span style={{ color: "#dee2e6" }}>|</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    readDeleteNotification("delete");
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#dc3545",
                    fontSize: "12px",
                    fontWeight: "500",
                    cursor: "pointer",
                    padding: "3px 6px",
                    borderRadius: "4px",
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#fff5f5";
                    e.currentTarget.style.color = "#c82333";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#dc3545";
                  }}
                >
                  <i className="fas fa-trash-alt" style={{ marginRight: "4px", fontSize: "11px" }}></i>
                  Clear All
                </button>
              </div>
            )}
          </div>
        </li>
        {/* /Notifications */}
        <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleProfile}
          >
            {" "}
            <span className="user-img me-1">
              <Image type="user" src={user?.profile_image} alt="img" style={{ objectFit: "cover" }} />
              <span className="status online" />
            </span>
            <span>{ProfileName ? `${ProfileName}` : "Admin"}</span>
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end profile-dropdown-modern ${profile ? "show" : ""
              }`}
            style={{
              minWidth: "280px",
              padding: "0",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              overflow: "hidden"
            }}
          >
            {/* Profile Header Section */}
            <div style={{
              background: headerGradient,
              padding: "20px",
              color: "white"
            }}>
              <div className="d-flex align-items-center">
                <div className="avatar" style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "3px solid rgba(255, 255, 255, 0.3)",
                  flexShrink: 0
                }}>
                  <Image 
                    src={user?.profile_image} 
                    type="user" 
                    style={{ objectFit: "cover", width: "100%", height: "100%" }} 
                  />
                </div>
                <div className="ms-3" style={{ flex: 1, minWidth: 0 }}>
                  <div className="fw-bold" style={{ fontSize: "16px", marginBottom: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {user?.first_name} {user?.last_name}
                  </div>
                  <div style={{ fontSize: "12px", opacity: 0.9, marginBottom: "2px" }}>
                    {user?.role?.name || "User"}
                  </div>
                  {user?.emp_no && (
                    <div style={{ fontSize: "11px", opacity: 0.8 }}>
                      ID: {user.emp_no}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Email Section */}
            <div style={{
              padding: "12px 20px",
              borderBottom: "1px solid #f0f0f0",
              background: "#fafafa"
            }}>
              <div className="d-flex align-items-center">
                <i className="fas fa-envelope" style={{ 
                  color: "rgb(211, 0, 26)", 
                  marginRight: "10px",
                  fontSize: "14px",
                  width: "18px",
                  flexShrink: 0
                }}></i>
                <div style={{ 
                  fontSize: "14px", 
                  color: "#212529",
                  fontWeight: "500",
                  wordBreak: "break-word",
                  flex: 1,
                  minWidth: 0
                }}>
                  {userEmail || user?.email || "No email"}
                </div>
              </div>
            </div>

            {/* Profile Link */}
            {
              user?.role?.access_scope !== "store_manager" && 
              <Link 
                className="dropdown-item profile-link-item" 
                to={user?.role?.access_scope == "store_manager" ? "#" : `/employees/${user?.id}?profile=true`} 
                onClick={(e) => user?.role?.access_scope == "store_manager" && e.preventDefault()}
                style={{
                  padding: "14px 20px",
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  color: "#212529",
                  transition: "background-color 0.2s",
                  borderBottom: "1px solid #f0f0f0"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
              >
                <i className="fas fa-user-circle" style={{ 
                  color: "rgb(211, 0, 26)", 
                  marginRight: "12px",
                  fontSize: "16px",
                  width: "20px"
                }}></i>
                <span style={{ fontSize: "14px" }}>View Profile</span>
                <i className="fas fa-chevron-right ms-auto" style={{ 
                  color: "#adb5bd",
                  fontSize: "12px"
                }}></i>
              </Link>
            }

            {/* Logout Button */}
            <Link 
              className="dropdown-item logout-item" 
              to="/" 
              onClick={handleLogout}
              style={{
                padding: "14px 20px",
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "rgb(211, 0, 26)",
                transition: "background-color 0.2s",
                borderTop: "1px solid #f0f0f0"
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fff5f5"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
            >
              <i className="fas fa-sign-out-alt" style={{ 
                color: "rgb(211, 0, 26)", 
                marginRight: "12px",
                fontSize: "16px",
                width: "20px"
              }}></i>
              <span style={{ fontSize: "14px", fontWeight: "500" }}>Logout</span>
            </Link>
          </div>
        </li>
      </ul>
      {/* /Header Menu */}
      {/* Mobile Menu */}
      


     















      <div 
      // style={{width:95}} 
      className="dropdown mobile-user-menu" style={{ marginRight: "4px" }}>
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onClick={handleProfile}
        >
          {
            user.profile_image ?
            <div   className="avatar">
            <Image src={user.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </div>:
          <div  style={{width:40,height:40, backgroundColor:"white", borderRadius:"50%"}} className="avatar text-sm text-normal text-danger">
        {/* <div className=" d-flex justify-content-center align-items-center text-capitalize text-danger" style={{width:40,height:40, backgroundColor:"white", borderRadius:"50%"}}> */}
         <span>{user?.first_name&&user?.first_name[0]}{user?.last_name ? user?.last_name[0]:""}</span> 
        {/* </div> */}
        </div>

          }
          
          {/* <i className="fa fa-ellipsis-v" /> */}
        </Link>
        <div 
          className="dropdown-menu dropdown-menu-end dropdown-menu-right profile-dropdown-modern mobile-profile-dropdown"
          style={{
            minWidth: isMobile ? "240px" : "280px",
            padding: "0",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            border: "1px solid rgba(0, 0, 0, 0.08)",
            overflow: "hidden"
          }}
        >
          {/* Profile Header Section */}
          <div className="mobile-profile-header" style={{
            background: headerGradient,
            padding: isMobile ? "12px 16px" : "20px",
            color: "white"
          }}>
            <div className="d-flex align-items-center">
              <div className="avatar" style={{
                width: isMobile ? "40px" : "56px",
                height: isMobile ? "40px" : "56px",
                borderRadius: "50%",
                overflow: "hidden",
                border: isMobile ? "2px solid rgba(255, 255, 255, 0.3)" : "3px solid rgba(255, 255, 255, 0.3)",
                flexShrink: 0
              }}>
                <Image 
                  src={user?.profile_image} 
                  type="user" 
                  style={{ objectFit: "cover", width: "100%", height: "100%" }} 
                />
              </div>
              <div className={isMobile ? "ms-2" : "ms-3"} style={{ flex: 1, minWidth: 0 }}>
                <div className="fw-bold" style={{ fontSize: isMobile ? "14px" : "16px", marginBottom: isMobile ? "0px" : "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: isMobile ? "1.2" : "1.4" }}>
                  {user?.first_name} {user?.last_name}
                </div>
                <div style={{ fontSize: isMobile ? "11px" : "12px", opacity: 0.9, marginBottom: isMobile ? "0px" : "2px", lineHeight: isMobile ? "1.2" : "1.4", marginTop: isMobile ? "2px" : "0" }}>
                  {user?.role?.name || "User"}
                </div>
                {user?.emp_no && (
                  <div style={{ fontSize: isMobile ? "10px" : "11px", opacity: 0.8, lineHeight: isMobile ? "1.2" : "1.4", marginTop: isMobile ? "2px" : "0" }}>
                    ID: {user.emp_no}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Email Section */}
          <div className="mobile-profile-email" style={{
            padding: isMobile ? "6px 16px" : "12px 20px",
            borderBottom: isMobile ? "none" : "1px solid #f0f0f0",
            background: "#fafafa",
            marginBottom: isMobile ? "0" : "0"
          }}>
            <div className="d-flex align-items-center">
              <i className="fas fa-envelope" style={{ 
                color: "rgb(211, 0, 26)", 
                marginRight: isMobile ? "8px" : "10px",
                fontSize: isMobile ? "12px" : "14px",
                width: isMobile ? "14px" : "18px",
                flexShrink: 0
              }}></i>
              <div style={{ 
                fontSize: isMobile ? "12px" : "14px", 
                color: "#212529",
                fontWeight: "500",
                wordBreak: "break-word",
                flex: 1,
                minWidth: 0
              }}>
                {userEmail || user?.email || "No email"}
              </div>
            </div>
          </div>

          {/* Profile Link */}
          <Link 
            className="dropdown-item profile-link-item mobile-profile-link" 
            to={user?.role?.access_scope == "store_manager" ? "#" : `/employees/${user?.id}?profile=true`} 
            onClick={(e) => user?.role?.access_scope == "store_manager" && e.preventDefault()}
            style={{
              padding: isMobile ? "8px 16px" : "14px 20px",
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#212529",
              transition: "background-color 0.2s",
              borderBottom: isMobile ? "none" : "1px solid #f0f0f0",
              marginTop: isMobile ? "0" : "0",
              marginBottom: isMobile ? "0" : "0"
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
          >
            <i className="fas fa-user-circle" style={{ 
              color: "rgb(211, 0, 26)", 
              marginRight: isMobile ? "10px" : "12px",
              fontSize: isMobile ? "14px" : "16px",
              width: isMobile ? "16px" : "20px"
            }}></i>
            <span style={{ fontSize: isMobile ? "13px" : "14px" }}>View Profile</span>
            <i className="fas fa-chevron-right ms-auto" style={{ 
              color: "#adb5bd",
              fontSize: isMobile ? "10px" : "12px"
            }}></i>
          </Link>

          {/* Logout Button */}
          <Link 
            className="dropdown-item logout-item mobile-profile-logout" 
            to="/" 
            onClick={handleLogout}
            style={{
              padding: isMobile ? "8px 16px" : "14px 20px",
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "rgb(211, 0, 26)",
              transition: "background-color 0.2s",
              borderTop: isMobile ? "none" : "1px solid #f0f0f0",
              marginTop: isMobile ? "0" : "0"
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fff5f5"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
          >
            <i className="fas fa-sign-out-alt" style={{ 
              color: "rgb(211, 0, 26)", 
              marginRight: isMobile ? "10px" : "12px",
              fontSize: isMobile ? "14px" : "16px",
              width: isMobile ? "16px" : "20px"
            }}></i>
            <span style={{ fontSize: isMobile ? "13px" : "14px", fontWeight: "500" }}>Logout</span>
          </Link>
        </div>
      </div>

      <li className="mobile-user-menu" style={{ marginRight: "0", position: "relative" }}>
          <Link
            to="#"
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              handleNotification();
            }}
            style={{ position: "relative", display: "inline-block" }}
          >
            <i>
              <FaRegBell />
            </i>
            {
              notificationCount>0&&
              <span className="badge badge-pill" style={{
                position: "absolute",
                top: "50%",
                right: "-6px",
                transform: "translateY(-50%)",
                backgroundColor: "rgb(211, 0, 26)",
                color: "white",
                borderRadius: "10px",
                padding: "2px 5px",
                fontSize: "9px",
                fontWeight: "600",
                minWidth: "16px",
                height: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: "1",
                border: "2px solid white"
              }}>{notificationCount}</span>

            }
          </Link>
        </li>
        {notification && isMobile && (
          <>
            {/* Backdrop */}
            <div
              onClick={handleNotification}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 9999
              }}
            />
            {/* Notification Popup */}
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                position: "fixed",
                top: "60px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "calc(100vw - 32px)",
                maxWidth: "400px",
                maxHeight: "calc(100vh - 120px)",
                zIndex: 10000,
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                border: "1px solid rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column"
              }}
            >
              {/* Modern Header */}
              <div style={{
                padding: "12px 16px",
                background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, rgb(244, 59, 72) 50%, rgb(252, 19, 61) 100%)",
                color: "white",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
              }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-bell" style={{ marginRight: "8px", fontSize: "16px" }}></i>
                    <span style={{ fontSize: "15px", fontWeight: "600" }}>Notifications</span>
                    {notificationCount > 0 && (
                      <span style={{
                        marginLeft: "6px",
                        background: "rgba(255, 255, 255, 0.3)",
                        padding: "1px 6px",
                        borderRadius: "10px",
                        fontSize: "11px",
                        fontWeight: "600"
                      }}>
                        {notificationCount}
                      </span>
                    )}
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNotification();
                    }}
                    style={{
                      background: "rgba(255, 255, 255, 0.2)",
                      border: "none",
                      color: "white",
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      padding: 0
                    }}
                  >
                    <i className="fas fa-times" style={{ fontSize: "12px" }}></i>
                  </button>
                </div>
                <div className="d-flex align-items-center" style={{ gap: "4px", marginTop: "8px" }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      filterNotifications(e, "");
                    }}
                    style={{
                      background: isRead === false ? "rgba(255, 255, 255, 0.35)" : "rgba(255, 255, 255, 0.2)",
                      border: "none",
                      color: "white",
                      padding: "3px 10px",
                      borderRadius: "5px",
                      fontSize: "11px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                  >
                    All
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      filterNotifications(e, false);
                    }}
                    style={{
                      background: isRead === "" ? "rgba(255, 255, 255, 0.35)" : "rgba(255, 255, 255, 0.2)",
                      border: "none",
                      color: "white",
                      padding: "3px 10px",
                      borderRadius: "5px",
                      fontSize: "11px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                  >
                    Unread
                  </button>
                </div>
              </div>

              {/* Notification List */}
              <div style={{
                flex: 1,
                overflowY: "auto",
                background: "#ffffff",
                minHeight: 0
              }}>
                {notifications.length === 0 ? (
                  <div style={{
                    padding: "32px 16px",
                    textAlign: "center",
                    color: "#6c757d"
                  }}>
                    <i className="far fa-bell-slash" style={{ fontSize: "28px", marginBottom: "10px", opacity: 0.5 }}></i>
                    <div style={{ fontSize: "13px" }}>No notifications</div>
                  </div>
                ) : (
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {notifications.map((val, index) => {
                      const isUnread = !val?.is_read;
                      return (
                        <li 
                          key={index}
                          style={{
                            borderBottom: "1px solid #f0f0f0",
                            transition: "background-color 0.2s",
                            background: isUnread ? "#fff5f5" : "#ffffff"
                          }}
                        >
                          <Link
                            to={val?.data?.type == "leave_request" ? `/leaves-employee?id=${val.data?.id}&modal=true` : val?.data?.type == "expense_claim" ? `/expenses?id=${val.data?.id}&modal=true` : "#"}
                            onClick={() => handleNotification()}
                            style={{
                              display: "flex",
                              padding: "10px 16px",
                              textDecoration: "none",
                              color: "inherit"
                            }}
                          >
                            <div style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "8px",
                              background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, rgb(244, 59, 72) 50%, rgb(252, 19, 61) 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                              marginRight: "10px"
                            }}>
                              <i className={`fas ${val?.data?.type == "leave_request" ? "fa-calendar" : val?.data?.type == "expense_claim" ? "fa-dollar-sign" : "fa-bell"}`}
                                style={{ color: "white", fontSize: "14px" }}
                              ></i>
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{
                                fontSize: "13px",
                                fontWeight: isUnread ? "600" : "500",
                                color: "#212529",
                                marginBottom: "3px",
                                lineHeight: "1.4"
                              }}>
                                {val.title}
                              </div>
                              <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "4px"
                              }}>
                                <span 
                                  style={{
                                    fontSize: "11px",
                                    color: "#6c757d"
                                  }}
                                >
                                  {timeSince(val.created_at)}
                                </span>
                                <span
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (!val?.is_read) {
                                      viewNotificationHandler(val);
                                    }
                                  }}
                                  style={{
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    transition: "background-color 0.2s"
                                  }}
                                >
                                  <i className={val?.is_read ? "far fa-eye" : "far fa-eye-slash"}
                                    style={{
                                      color: val?.is_read ? "#6c757d" : "rgb(211, 0, 26)",
                                      fontSize: "12px"
                                    }}
                                  ></i>
                                </span>
                              </div>
                            </div>
                            {isUnread && (
                              <div style={{
                                width: "6px",
                                height: "6px",
                                borderRadius: "50%",
                                background: "rgb(211, 0, 26)",
                                flexShrink: 0,
                                marginLeft: "6px",
                                marginTop: "3px"
                              }}></div>
                            )}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>

              {/* Footer Actions */}
              {notifications.length > 0 && (
                <div style={{
                  padding: "10px 16px",
                  borderTop: "1px solid #f0f0f0",
                  background: "#fafafa",
                  display: "flex",
                  justifyContent: "center",
                  gap: "12px"
                }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      readDeleteNotification("read");
                    }}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "rgb(211, 0, 26)",
                      fontSize: "12px",
                      fontWeight: "500",
                      cursor: "pointer",
                      padding: "3px 6px",
                      borderRadius: "4px",
                      transition: "all 0.2s"
                    }}
                  >
                    <i className="fas fa-check-double" style={{ marginRight: "4px", fontSize: "11px" }}></i>
                    Mark Read
                  </button>
                  <span style={{ color: "#dee2e6" }}>|</span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      readDeleteNotification("delete");
                    }}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#dc3545",
                      fontSize: "12px",
                      fontWeight: "500",
                      cursor: "pointer",
                      padding: "3px 6px",
                      borderRadius: "4px",
                      transition: "all 0.2s"
                    }}
                  >
                    <i className="fas fa-trash-alt" style={{ marginRight: "4px", fontSize: "11px" }}></i>
                    Clear All
                  </button>
                </div>
              )}
            </div>
            </>
          )}





      {/* /Mobile Menu */}
      <style>{`
        @media (max-width: 575px) {
          .mobile-user-menu {
            margin-right: 4px !important;
          }
          .mobile-user-menu:last-child {
            margin-right: 0 !important;
          }
          .mobile-user-menu .badge-pill {
            position: absolute !important;
            top: 50% !important;
            right: -6px !important;
            transform: translateY(-50%) !important;
            background-color: rgb(211, 0, 26) !important;
            color: white !important;
            border-radius: 10px !important;
            padding: 2px 5px !important;
            font-size: 9px !important;
            font-weight: 600 !important;
            min-width: 16px !important;
            height: 16px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            line-height: 1 !important;
            border: 2px solid white !important;
          }
          .mobile-profile-dropdown {
            min-width: 240px !important;
            max-width: 240px !important;
          }
          .mobile-profile-header {
            padding: 12px 16px !important;
          }
          .mobile-profile-email {
            padding: 6px 16px !important;
            border-bottom: none !important;
            margin-bottom: 0 !important;
          }
          .mobile-profile-link,
          .mobile-profile-logout {
            padding: 8px 16px !important;
            border-top: none !important;
            border-bottom: none !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Header;
